import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Registro from "./pages/Registro";
import ChatbotQR from "./Components/chatbotqr.jsx";
import CONFIG from "./config";

function App() {
  const [autenticado, setAutenticado] = useState(false);
  const [cargando] = useState(false);
  const [usuario, setUsuario] = useState("");

  const handleLogin = (user) => {
    setAutenticado(true);
    setUsuario(user);
  };

  const handleLogout = async () => {
    try {
      await fetch(`${CONFIG.API_URL}cerrar_sesion.php`, {
        method: "POST",
        credentials: "include",
      });
    } catch {} finally {
      setAutenticado(false);
      setUsuario("");
    }
  };

  if (cargando) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        background: "#111B21",
        color: "#8696A0",
        fontFamily: "system-ui, sans-serif",
        fontSize: "1.1rem",
      }}>
        Cargando...
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/regipile" element={<Registro />} />
        {autenticado ? (
          <>
            <Route path="/" element={<Dashboard onLogout={handleLogout} />} />
            <Route path="/qr" element={<ChatbotQR />} />
          </>
        ) : (
          <Route path="*" element={<Login onLogin={handleLogin} />} />
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
